import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory, {
  PaginationProvider,
  SizePerPageDropdownStandalone,
  PaginationListStandalone,
} from 'react-bootstrap-table2-paginator'
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css'
import { Container, Row, Col } from 'reactstrap'
import './Backup365UsersTable.css'

const { SearchBar } = Search
const { ExportCSVButton } = CSVExport

const UsersTable = ({ users, selectedCompany }) => {
  const columns = [
    {
      dataField: 'displayName',
      text: 'Display Name',
      sort: true,
      filter: textFilter({ placeholder: 'Filter by name...' }),
    },
    {
      dataField: 'userPrincipleName',
      text: 'Email / UPN',
      sort: true,
      filter: textFilter({ placeholder: 'Filter by UPN...' }),
    },
    {
      dataField: 'mailboxType',
      text: 'Mailbox Type',
      sort: true,
      filter: textFilter({ placeholder: 'Filter by type...' }),
    },
    {
      dataField: 'ositLicenseType',
      text: 'OSIT License Type',
      sort: true,
      filter: textFilter({ placeholder: 'Filter by license...' }),
    },
    {
      dataField: 'licenseReason',
      text: 'License Reason',
      sort: true,
      filter: textFilter({ placeholder: 'Filter by reason...' }),
    },
    {
      dataField: 'accountEnabled',
      text: 'Enabled',
      sort: true,
      formatter: (cell) => (cell ? 'Yes' : 'No'),
      filter: selectFilter({
        options: {
          true: 'Enabled',
          false: 'Disabled',
        },
        placeholder: 'Filter Enabled...',
      }),
      csvFormatter: (cell) => (cell ? 'True' : 'False'),
    },
  ]

  const defaultSorted = [{ dataField: 'displayName', order: 'asc' }]

  const completeUsers = users.filter((u) => u.ositLicenseType === 'Complete')
  const mailboxUsers = users.filter((u) => u.ositLicenseType === 'Mailbox')

  const exportUsernamesCsv = (filename, users) => {
    // Header
    const header = 'Username'

    // Rows (using user.userPrincipalName)
    const rows = users.map((u) => `"${u.userPrincipleName ?? ''}"`)

    const csv = [header, ...rows].join('\n')

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  return (
    <Container fluid className="mt-3">
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          totalSize: users.length,
          sizePerPageList: [
            { text: '10', value: 10 },
            { text: '20', value: 20 },
            { text: '50', value: 50 },
            { text: '100', value: 100 },
            { text: 'All', value: users.length },
          ],
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            data={users || []}
            columns={columns}
            exportCSV={{
              fileName: 'Backup365Users.csv',
              onlyExportFiltered: true,
              exportAll: true,
            }}
            search
          >
            {(props) => (
              <>
                <div className="backup365-table-toolbar d-flex justify-content-between align-items-center mb-3 flex-wrap">
                  <div className="d-flex align-items-center flex-wrap" style={{ gap: '12px' }}>
                    <ExportCSVButton className="btn btn-outline-primary" style={{ height: '38px' }} {...props.csvProps}>
                      Export All Users
                    </ExportCSVButton>

                    <button
                      className="btn btn-outline-primary"
                      style={{ height: '38px' }}
                      onClick={() =>
                        exportUsernamesCsv(`${selectedCompany.label}-complete-usernames.csv`, completeUsers)
                      }
                    >
                      Export Complete Users
                    </button>

                    <button
                      className="btn btn-outline-primary"
                      style={{ height: '38px' }}
                      onClick={() => exportUsernamesCsv(`${selectedCompany.label}-mailbox-usernames.csv`, mailboxUsers)}
                    >
                      Export Mailbox Users
                    </button>
                  </div>

                  <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                    <SizePerPageDropdownStandalone btnContextual="btn-outline-secondary" {...paginationProps} />

                    <div style={{ minWidth: '180px' }}>
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </div>
                </div>

                {/* Table */}
                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    bordered={false}
                    hover
                    condensed
                    wrapperClasses="table-striped table-hover"
                    defaultSorted={defaultSorted}
                    {...props.baseProps}
                    pagination={paginationFactory()}
                    filter={filterFactory()}
                    filterPosition="top"
                    {...paginationTableProps}
                  />
                </div>
              </>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    </Container>
  )
}

export default UsersTable
